import { IButton } from 'types/interfaces';
import './button.scss';
import SvgIcon from 'components/commons/icons/SvgIcon';
import Image from 'components/commons/image/Image';
import { ClipLoader } from 'react-spinners';

export default function Button(props: IButton) {
  return (
    <button
      type={props.type ? props.type : 'button'}
      className={`${props.className ? props.className + ' button' : 'button'}${
        props.tooltip ? ' tooltip' : ''
      }`}
      disabled={props.disabled}
      onClick={() => props.onClick && props.onClick()}
      style={{
        height: props.height ? props.height : '45px',
        width: props.width ? props.width : '45px',
        background: props.background ? props.background : 'white',
        ...props.style,
      }}
      tabIndex={props.tabIndex}
      aria-label={
        props.ariaLabel
          ? props.ariaLabel
          : props.title
          ? props.title
          : props.ImagePromise || props.icon
          ? 'Icono'
          : 'Button'
      }
      aria-disabled={props.disabled}
    >
      {props.icon &&
        (typeof props.icon === 'string' ? (
          <Image
            className={`${props.className} icon`}
            alt={props.title ? props.title : props.ariaLabel}
            src={props.icon}
            style={{ marginRight: '3px' }}
          />
        ) : (
          <SvgIcon
            ariaLabel={
              props.ariaLabel
                ? props.ariaLabel
                : props.title
                ? props.title
                : props.ImagePromise || props.icon
                ? 'Icono'
                : 'Button'
            }
            Icon={props.icon}
            color={props?.color}
            style={{ marginRight: '0px' }}
          />
        ))}

      {props.ImagePromise && props.ImagePromise}

      {props.title ? (
        <span style={{ color: props.color }}>{props.loading ? <ClipLoader cssOverride={{marginTop:'2px'}} color={'#FFF'} speedMultiplier={0.8} size={25} /> : props.title}</span>
      ) : (
        !props.printClassName &&
        !props.icon &&
        !props.ImagePromise &&
        !props.children && <span>Button</span>
      )}

      {props.printClassName && <span>{props.className}</span>}

      {props.badge && <span className='badge'>{props.badge}</span>}

      {props.tooltip && <span className='tooltip'>{props.tooltip}</span>}
      {props.children}
    </button>
  );
}
